import { FileArrowUpDownOutlineIcon } from './FileArrowUpDownOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4D08B9C5-576C-430B-9319-597190ABA71D
 * name file-arrow-up-down-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-arrow-up-down-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileUploadDownloadOutlineIcon = FileArrowUpDownOutlineIcon;
export default FileUploadDownloadOutlineIcon